import { topicCategoryRepository } from "../../../providers/repositories/topicCategoryRepository";
import { TopicCategoryFormData } from "../entities/TopicCategory";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const addUpdateTopicCategoryUseCase = {
    async exec(
        data: TopicCategoryFormData,
        id: number | string | null,
    ): Promise<boolean> {
        try {
            await topicCategoryRepository.addUpdate(data, id);

            if (id) {
                toast.success(t("action.updateSuccess"));
            }
            return true;
        } catch (error) {
            Logger.error("updateTopicCategoryUseCase", error);
            toast.error(t("action.updateError"));
        }
        return false;
    },
};
